import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {IconComponent, IconType} from "../icon/icon.component";

@Component({
    selector: 'app-badge',
    imports: [
        IconComponent,
    ],
    templateUrl: './badge.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './badge.component.scss'
})
export class BadgeComponent {
  @Input() public size: 'small' | 'medium' | 'large' = 'small';
  @Input() public icon: string = '';
  @Input() public type: IconType = 'regular';
}
